import { BookmarkActions, BookmarkActionTypes } from './actions';
import { ListItemData } from '../../pages/networkDoctors/utils/mapData';

export const reducer = (state: ListItemData[], action: BookmarkActions): ListItemData[] => {
  switch (action.type) {
    case BookmarkActionTypes.ADD: {
      return [...state, action.payload];
    }
    case BookmarkActionTypes.REMOVE: {
      return state.filter((a) => a.bookmarkId !== action.payload.bookmarkId);
    }
    case BookmarkActionTypes.SET: {
      return [...action.payload];
    }
    default:
      return state;
  }
};
